module.exports = __webpack_public_path__ + "img/menu-icon.f00e8416.svg";